import { RefObject, useCallback, useRef, useState } from 'react';
export function useSyncedState<T = undefined>(): [
  T | undefined,
  (value: T | ((prev: T | undefined) => T | undefined)) => void,
  RefObject<T | undefined>,
];
export function useSyncedState<T>(
  initialState: T | (() => T)
): [T, (value: T | ((prev: T) => T)) => void, RefObject<T>];
// 实现签名需要兼容所有情况
export function useSyncedState<T>(
  initialState?: T | (() => T)
): [
  T | undefined,
  (value: T | ((prev: T | undefined) => T | undefined)) => void,
  RefObject<T | undefined>,
] {
  const [state, setStateInternal] = useState(initialState);
  const stateRef = useRef(state);

  const setState = useCallback((value: T | ((prev: T | undefined) => T | undefined)) => {
    if (typeof value === 'function') {
      const newState = (value as (prev: T | undefined) => T | undefined)(stateRef.current);
      stateRef.current = newState;
      setStateInternal(newState);
    } else {
      const newState = value;
      stateRef.current = newState;
      setStateInternal(newState);
    }
  }, []);

  return [state, setState, stateRef] as const;
}
